import React from 'react';
import { ModalsKeys } from 'global';
import { z } from 'zod';
import { useModal } from 'hooks/useModal';
import { SubmitHandler, useForm } from 'react-hook-form';
import { InputField, SelectField } from 'components/form';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { chargeCategoryOptions, ChargeType } from '../../constants';

const newChargeSchema = z.object({
  name: z.string().min(3),
  category: z.nativeEnum(ChargeType),
});

type CreateChargeFormValue = z.infer<typeof newChargeSchema>;

export const CreateChargesDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.CreateChargesEquipmentDialog);

  const { control, handleSubmit } = useForm<CreateChargeFormValue>({
    defaultValues: { category: ChargeType.TaxesAndFees, name: '' },
    resolver: zodResolver(newChargeSchema),
  });

  const onSubmit: SubmitHandler<CreateChargeFormValue> = newCharge => {
    handleClose();
    data.onConfirm(newCharge);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={handleClose}>
      <DialogTitle>Create Charge</DialogTitle>

      <DialogContent dividers>
        <Stack gap="1.5rem">
          <SelectField name="category" control={control} label="Select category" options={chargeCategoryOptions} />

          <InputField name="name" control={control} inputProps={{ placeholder: 'Charge Name' }} />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>

        <Button variant="contained" onClick={handleSubmit(onSubmit)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
